const config = {
	title: 'Temperature Daily Summary Report',
	name: 'temperatureDailySummary',
	defaultSort: 'Date desc',
	api: 'telemetry/summary',
	controllerType: 'elastic',
	readOnly: true,
	module: 'temperature',
	columns: [
		{
			field: 'sensorId',
			width: 220,
			header: 'Sensor',
			lookup: 'sensor',
			required: true,
			hideable: false,
			elasticFilter: false,
			sortable: false,
			filterable: false
		},
		{
			field: 'sensorCode',
			flex: 1,
			header: 'Sensor Code',
			type: 'string',
			readOnly: true,
			elasticFilter: false,
			sortable: false,
			filterable: false
		},
		{
			field: 'Date',
			flex: 1,
			header: 'Date',
			type: 'date',
			time: false,
			isLocal: true,
			elasticFilter: false,
			showDateOnly: true
		},
		{ field: 'avg', flex: 1, header: 'Avg (C\u00B0)', type: 'number', elasticFilter: false },
		{ field: 'duration', flex: 1, header: 'Duration OOR', elasticFilter: false, filterable: false },
		{ field: 'min', flex: 1, header: 'Min (C\u00B0)', type: 'number', elasticFilter: false, filterable: false },
		{ field: 'max', flex: 1, header: 'Max (C\u00B0)', type: 'number', elasticFilter: false, filterable: false }
	]
};

export default config;
